import { keyframes } from '@emotion/core';
import styled from '@emotion/styled';
import { animated } from 'react-spring';
import scale from '../../utilities/scale';
import { Colors } from '../../constants';

export const Container = styled.div<{
  registerDeviceStep: boolean;
  signUpPage?: string;
}>(({ registerDeviceStep, signUpPage }) => {
  const backgroundColor = '';

  return {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    ...(signUpPage && registerDeviceStep
      ? {
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='1440' height='900' viewBox='0 0 1440 900' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0_269_27205)'%3E%3Crect width='1440' height='900' fill='url(%23paint0_linear_269_27205)'/%3E%3Crect width='1440' height='900' fill='url(%23paint1_linear_269_27205)'/%3E%3Cpath opacity='0.5' d='M111 -4.9284 C337.922 226.336 701.463 221.865 922.871 -5.0571 l -410.928 -400.9429 L111 -4.9284Z' fill='%23879CFF'/%3E%3Cg style='mix-blend-mode:multiply' opacity='0.5'%3E%3Cpath d='M822.47 921.487C641.569 584.365 94.3422 525.931 -399.612 790.989L-72.0205 1401.48L822.47 921.487Z' fill='%23542499'/%3E%3C/g%3E%3Cpath opacity='0.5' d='M1014.02 515.456C935.36 651.701 982.016 825.821 1118.26 904.482L1607.14 1241.56L1940.39 765.86L1403.05 411.217C1266.8 332.556 1092.68 379.212 1014.02 515.456Z' fill='%230047D4'/%3E%3C/g%3E%3Cdefs%3E%3ClinearGradient id='paint0_linear_269_27205' x1='720' y1='0' x2='720' y2='900' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%230047D4'/%3E%3Cstop offset='1' stop-color='%234270EB'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint1_linear_269_27205' x1='-68' y1='-101' x2='1503.5' y2='999.5' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%230047D4'/%3E%3Cstop offset='1' stop-color='%230530A6'/%3E%3C/linearGradient%3E%3CclipPath id='clip0_269_27205'%3E%3Crect width='1440' height='900' fill='white'/%3E%3C/clipPath%3E%3CclipPath id='clip1_269_27205'%3E%3Crect width='96' height='96' fill='white' transform='translate(213 677.5)'/%3E%3C/clipPath%3E%3CclipPath id='clip2_269_27205'%3E%3Crect width='96' height='96' fill='white' transform='translate(908 670.5)'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A")`,
          backgroundSize: 'cover',
        }
      : { backgroundColor: backgroundColor }),
  };
});

export const Header = styled.div({
  display: 'flex',
  flexDirection: 'row',
  padding: `${scale(150)} ${scale(150)} ${scale(119)}  ${scale(150)}`,
  '@media (max-width: 767px)': {
    padding: `${scale(50)} ${scale(50)}`,
  },
});

export const Main = styled.div({
  flex: 1,
  position: 'relative',
});

export const AnimationLayer = styled(animated.div)({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
});

export const Inner = styled.div({
  padding: `${scale(0)} ${scale(150)}`,

  '@media (max-width: 767px)': {
    padding: `${scale(50)} ${scale(50)}`,
  },
});

export const Error = styled.div({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  color: '#000000',
  fontSize: scale(32),
  padding: `${scale(0)} ${scale(0)}`,

  '@media (max-width: 767px)': {
    padding: `${scale(50)} ${scale(50)}`,
  },
});

export const ErrorBadge = styled.div({
  width: scale(80),
  height: scale(80),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,

  '& > svg': {
    width: scale(56),
    height: scale(56),
  },
});

export const Footer = styled.div<{ hasError: boolean }>(({ hasError }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: `${scale(100)} ${scale(150)}`,
  borderTop: 'solid 1px rgb(41, 39, 52, 0.2)',
  fontSize: scale(25),
  fontWeight: 300,
  lineHeight: 1.5,
  color: '#000000',
  backgroundColor: hasError ? '#edde4f' : '#CCDAF7',

  '@media (max-width: 767px)': {
    padding: `${scale(50)} ${scale(50)}`,
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
}));

export const DeviceStatus = styled.div({
  display: 'flex',
  flexDirection: 'column',

  '@media (max-width: 767px)': {
    marginBottom: scale(24),
  },
});

// Modified from https://github.com/daneden/animate.css/blob/master/source/attention_seekers/bounce.css
const bounce = keyframes({
  'from, 20%, 53%, 80%, to': {
    animationTimingFunction: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
    transform: 'translate3d(0, 0, 0)',
  },

  '40%, 43%': {
    animationTimingFunction: 'cubic-bezier(0.755, 0.05, 0.855, 0.06)',
    transform: 'translate3d(0, -10px, 0)',
  },

  '70%': {
    animationTimingFunction: 'cubic-bezier(0.755, 0.05, 0.855, 0.06)',
    transform: 'translate3d(0, -5px, 0)',
  },
});

export const Help = styled.div({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  color: '#000000',
  fontSize: scale(30),
  fontWeight: 400,
  lineHeight: scale(33.45),

  '& > svg': {
    marginRight: scale(24),
    animationName: bounce,
    animationDuration: '1s',
    animationDelay: '180s',
    animationIterationCount: 3,
    animationFillMode: 'both',
    transformOrigin: 'center bottom',
  },

  '& > span': {
    marginBottom: '0.25em', // Align with help icon.
  },
});

export const CallToAction = styled.h1({
  width: scale(1620),
  height: scale(77),
  fontSize: scale(69.03),
  lineHeight: scale(76.96),
  fontWeight: 500,
  letterSpacing: '-0.5px',
  color: '#000000',
  marginTop: 0,
  marginBottom: scale(69),
});

export const StepTitle = styled.h2({
  width: scale(1620),
  height: scale(81),
  position: 'relative',
  fontSize: scale(45.11),
  fontWeight: 500,
  lineHeight: scale(50.3),
  paddingLeft: scale(120),
  paddingTop: scale(10),
  color: '#000000',
  marginTop: 0,
  marginBottom: scale(3.5),
});

export const StepBadge = styled.div({
  position: 'absolute',
  top: scale(-8),
  left: scale(82),
  width: scale(81),
  height: scale(81),
  transform: 'translate(-100%)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
});

export const StepDesciption = styled.h3({
  position: 'relative',
  fontSize: scale(35),
  fontWeight: 400,
  lineHeight: '52.5px',
  color: '#000000',
  paddingLeft: scale(120),
  margin: 0,
});

export const Code = styled.span({
  whiteSpace: 'nowrap',
  textTransform: 'uppercase',
  textDecoration: 'underline',
});

export const CodeConnect = styled.div({
  fontSize: scale(75.3),
  lineHeight: scale(83.9),
  fontWeight: 600,
  whiteSpace: 'nowrap',
  textTransform: 'uppercase',
  textAlign: 'center',
});

export const Link = styled.a({
  color: 'inherit',
  textDecoration: 'none',

  '&:hover': {
    textDecoration: 'underline',
  },
});

export const CTACardContainer = styled.div({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'stretch',
});

export const CTAOr = styled.div({
  fontSize: scale(44.4),
  lineHeight: scale(49.5),
  padding: scale(25),
  fontWeight: 700,
  borderRadius: scale(100),
  boxShadow: `${scale(-6)} ${scale(6)} ${scale(8)} 0 rgba(0, 0, 0, 0.2)`,
  backgroundColor: Colors.PRIMARY,
  color: '#ffffff',
});

export const Paragraph = styled.div({
  fontWeight: 500,
});

export const ActivationCodeContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: scale(4.8),
  alignSelf: 'center',
  width: scale(515),
  backgroundColor: '#EAFAF8',
  borderRadius: scale(31),
  color: '#0A3D4D',
  paddingTop: scale(20),
  paddingBottom: scale(20),
});

export const Label = styled.div({
  fontSize: scale(19.2),
  lineHeight: scale(21.4),
  fontWeight: 500,
  textAlign: 'center',
});

export const RegisterDeviceHeader = styled.div({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  padding: `${scale(69)} ${scale(150)} ${scale(54)}`,
  '@media (max-width: 767px)': {
    padding: `${scale(54)} ${scale(50)}`,
  },
});
